import { RootState } from '../redux/store';
import { connect, ConnectedProps } from 'react-redux';
import { FormicaProps, withFormica } from '../helpers/withFormica';
import ComponentName from '../constant/ComponentName';
import CollectionNames from '../constant/CollectionNames';
import { addPagePath, changePageFilter, changePagePath, clearPage } from '../redux/actions/PageActions';
import { ComponentState, setSelectedItems } from '../redux/actions/ComponentActions';
import StandardContainerComponent, { StandardSubscriptionComponentArgs } from '../helpers/StandardContainerComponent';
import Tracker from '../domain/tracker/Tracker';
import TrackerListViewerComponent from '../components/tracker/TrackerListViewerComponent';
import TrackerSchema from '../domain/tracker/TrackerSchema';
import ServiceContainer from '../config/ServiceContainer';
import { ServiceNames } from '../constant/ServiceNames';
import TrackerService from '../service/TrackerService';
import LanguageUtil from '../util/LanguageUtil';
import { BulkActionDependencyError } from 'redux/reducers/BulkActionReducer';

class TrackerContainer extends StandardContainerComponent<Props, State, Tracker, TrackerSchema> {
  private readonly trackerService: TrackerService = ServiceContainer.getInstance().get(ServiceNames.TRACKER);

  constructor(props: Props) {
    const args: StandardSubscriptionComponentArgs = {
      component: ComponentName.TRACKER,
      withSchema: true,
      itemCollection: CollectionNames.TRACKERS,
      label: LanguageUtil.get({ id: 'common.label.trackers', defaultMessage: 'Trackers' }),
    };
    super(props, args);
  }

  private getTrackerModelIds = (): string[] => {
    const {
      component: { selectedComponentIds },
    } = this.props;
    return selectedComponentIds.map((tracker: Tracker) => tracker.id);
  };

  protected async deployAll(): Promise<BulkActionDependencyError[]> {
    return await this.trackerService.bulkAction(this.getTrackerModelIds(), 'Deploy');
  }

  protected async undeployAll(): Promise<BulkActionDependencyError[]> {
    return await this.trackerService.bulkAction(this.getTrackerModelIds(), 'Undeploy');
  }

  protected async removeAll(): Promise<BulkActionDependencyError[]> {
    return await this.trackerService.bulkAction(this.getTrackerModelIds(), 'Remove');
  }

  protected async prepareCount() {
    const count = await this.trackerService.getTrackerCount(this.getCountFilter().build());
    this.setState({ totalRecord: count });
  }

  protected getListView() {
    const { itemBuilderView, items, permissions } = this.state;
    return (
      <TrackerListViewerComponent
        views={itemBuilderView?.getListViews()}
        trackers={items}
        loading={this.state.loading}
        currentModal={itemBuilderView?.getLastCurrent()}
        onSortChange={this.onSortChange}
        openTracker={this.openComponent}
        permissions={permissions}
      />
    );
  }
}

interface Props extends ReduxProps, FormicaProps {}

const mapStateToProps = (state: RootState) => ({
  itemView: state.page.itemView,
  currentCategory: state.page.currentCategory,
  pagePath: state.page.pagePath,
  categoryPages: state.category.pages,
  activePageIndex: state.page.activePageIndex,
  enrichedCategories: state.page.enrichedCategories,
  component: state.component as ComponentState,
  user: state.auth.user,
  attributes: state.auth.attributes,
});
const mapDispatchToProps = { addPagePath, changePagePath, clearPage, setSelectedItems, changePageFilter };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {}

export default withFormica(connector(TrackerContainer));
